module.exports = {
          srcSet: __webpack_public_path__ + "43e081ab7c1caad87a533e739a9c3e9a-126.png"+" 126w",
          images:[ {path: __webpack_public_path__ + "43e081ab7c1caad87a533e739a9c3e9a-126.png",width: 126,height: 49}],
          src: __webpack_public_path__ + "43e081ab7c1caad87a533e739a9c3e9a-126.png",
          toString:function(){return __webpack_public_path__ + "43e081ab7c1caad87a533e739a9c3e9a-126.png"},
          
          width: 126,
          height: 49
        }